
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./routes": () => {
return Promise.all(/*  | __federation_expose_routes */ [__webpack_require__.e("469"), __webpack_require__.e("91")]).then(() => (() => (__webpack_require__(134))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };